// extracted by mini-css-extract-plugin
export var categoryIcon = "_dl-5";
export var connectorContainer = "_dl-1";
export var connectorLine = "_dl-0";
export var minHeight0 = "_dl-6";
export var relativeUnitValueSelector = "_dl-2";
export var trifoldSelectorBody = "_dl-4";
export var trifoldSelectorList = "_dl-3";